'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _loadingAdminForm = require('./loading-admin-form.html');

var _loadingAdminForm2 = _interopRequireDefault(_loadingAdminForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _loadingAdminForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administration: '<',
    administrations: '<',
    animalTypes: '<',
    frequencies: '<',
    unitsDisplay: '<',
    submitTitle: '@',
    administrationChanged: '&',
    index: '<',
    showAdditionalButton: '<'
  },
  controller: function () {
    function LoadingAdminFormComponent(AnimalTypeService, EventEmitter) {
      'ngInject';

      _classCallCheck(this, LoadingAdminFormComponent);

      Object.assign(this, { AnimalTypeService: AnimalTypeService, EventEmitter: EventEmitter });
    }

    _createClass(LoadingAdminFormComponent, [{
      key: 'onSubmit',
      value: function onSubmit(shouldClose) {
        var administration = _extends({
          Isloading: true
        }, this.administration);

        if (!administration.DoseId) {
          this.administrations.push(administration);
        }

        this.administrationChanged(this.EventEmitter({
          administration: administration,
          index: this.index,
          shouldClose: shouldClose
        }));

        this.validateDuplicates();
      }
    }, {
      key: 'getMinimumAnimalWeight',
      value: function getMinimumAnimalWeight(species) {
        return this.AnimalTypeService.minimumAnimalWeight(species);
      }
    }, {
      key: 'getMaximumAnimalWeight',
      value: function getMaximumAnimalWeight(species) {
        return this.AnimalTypeService.maximumAnimalWeight(species);
      }
    }, {
      key: 'validateDuplicates',
      value: function validateDuplicates() {
        var _this = this;

        var isValid = true;

        if (this.administration) {
          var arrayIndex = this.administrations.findIndex(function (d) {
            return d.Isloading === true && d.Species === _this.administration.Species && d.MinWeight === _this.administration.MinWeight && d.MaxWeight === _this.administration.MaxWeight && d.DoseAmount === _this.administration.DoseAmount && d.DosePerDay === _this.administration.DosePerDay && d.LoadingPeriod === _this.administration.LoadingPeriod;
          });

          if (arrayIndex !== -1 && arrayIndex !== this.index) {
            isValid = false;
          }
        }

        this.loadingAdministrationForm.$setValidity('duplicate', isValid);
      }
    }]);

    return LoadingAdminFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/loading-admin-form/loading-admin-form.component.js